import React, { useState, useEffect, useContext, useRef } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import JobService from "../Controller/JobController";
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import ProjectService from "../../Setup/controller/ProjectMemberController/ProjectMemberController";
import { handleChange, handleSubmit } from "../Controller/CreateJobController";
import Common from '../../Common/Common';
import useDateFormat from '../../Common/fetchDateFormat';
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import { useTranslation } from 'react-i18next';
import Cookies from "js-cookie";
import IssueStatusService from "../../Setup/controller/IssueStatusController/IssueStatusController";
function JobList({ CustomerID, AssetID, StockID, ContractID, JobTab }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const redirectCallback = () => {
    navigate('/'); // Redirect to the login page
  };

  const activeDateFormat = useDateFormat();
  const RoleID = localStorage.getItem('RoleID');
  const HelpLink = localStorage.getItem('HelpLink');
  const location = useLocation();
  const url = new URL(window.location.origin + location.pathname);
  const pathname = "/job/job-list";
  const tableRef = useRef();
  const FormAction = "/JobsList";
  //FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);
  const [currentJobs, setCurrentJobs] = useState(null);
  const [modalInstance, setModalInstance] = useState(null);
  const { theme, toggleTheme } = useContext(ThemeContext);
  let accordTheme = "accordion-header-light";
  if (theme === "dark") {
    accordTheme = "accordion-header-dark";
  }
  const CompanyID = localStorage.getItem("CompanyID");
  const [jobList, setJobData] = useState([]);
  const [JobCount, setJobCount] = useState(0);
  const [showAssetDetailModal, setShowAssetDetailModal] = useState(false); // State to control AssetDetailModal visibility
  const [modalInstanceCustomerDetail, setModalInstanceCustomerDetail] = useState(null);
  const [ProjectList, setProject] = useState([]);
  const [formData, setFormData] = useState({
    IsOutstanding: 0,
  });
  const [ProjectID, setProjectID] = useState(localStorage.getItem("ProjectID") || ""); // Initial empty state
  const [validationError, setValidationError] = useState('');
  const [filteredJobList, setFilteredJobList] = useState([]); // Filtered job list
  const [showCompleted, setShowCompleted] = useState(0);
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState("0");
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [selectedStatus, setSelectedStatus] = useState(Cookies.get('selectedStatus') || '');
  // Items per page
  const [totalPages, setTotalPages] = useState(1); // Total number of pages
  const [searchQuery, setSearchQuery] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'IssueID', direction: 'desc' });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isJobDetailModal, setIsJobDetailModal] = useState(false);
  const setPageSizeInCookie = (pageSize) => {
    document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
  };
  const getPageSizeFromCookie = () => {
    const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
    return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
  };
  const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
  const redirecttoUnAuthorzied = () => {
    navigate('/Unauthorized'); // Redirect to the login page
  };
  // Helper to get page size from cookie
  const isMobile = window.innerWidth <= 768



  useEffect(() => {
    fetchIssueStatus();
    fetchJob(ProjectID, currentPage, pageSize, showCompleted, selectedStatus);
  }, [ProjectID, currentPage, pageSize, showCompleted, selectedStatus]);



  const handleFieldChange = (event) => {
    handleChange(event, formData, setFormData);
    if (event.target.name === "ProjectID") {
      setProjectID(event.target.value);
      localStorage.setItem("ProjectID", event.target.value);
      fetchJob(event.target.value, "0", "10", selectedStatus);
    }
  };
  const [IssueStatusList, setIssueStatus] = useState([]);
  const fetchIssueStatus = async () => {
    try {
      const redirectCallback = () => navigate('/');
      let list = await IssueStatusService.GetAllIssueStatus(redirectCallback);
      list = list.filter(x => x.IsCompleted < 1 && x.Complete < 1);
      setIssueStatus(list);
    } catch (error) {
      console.error('Error fetching issue statuses:', error);
    }
  };
  const fetchJob = async (projectID, page, size, showCompleted, selStatus) => {

    setLoading(true); // Start loading
    try {
      const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
      const PageSize = size.toString();
      const redirectCallback = () => navigate('/');
      let jobsData = await JobService.GetAllJobsMobile(redirectCallback, CustomerID, AssetID, StockID, ContractID, projectID, Start.toString(), PageSize.toString(),
        searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), selectedStatus);

      if (showCompleted === 0) {
        // jobsData = jobsData.filter(x => x.IsCompleted === 0);
      }
      if (selStatus > 0) {
        jobsData = jobsData.filter(x => x.IssueStatusID.toString() === selStatus.toString());
      }


      const JobCount = await JobService.GetJobCountMobile(redirectCallback, CustomerID, AssetID, StockID, ContractID, projectID, searchQuery, selectedStatus);
      setJobCount(JobCount[0].JobCount);

      setJobData(jobsData);
      setFilteredJobList(jobsData); // Update filtered list for rendering
      setTotalPages(Math.ceil(JobCount[0].JobCount / size)); // Set total pages dynamically
    } catch (error) {
      console.error('Error fetching jobs:', error);
    } finally {
      setLoading(false); // Stop loading after fetching
    }
  };

  useEffect(() => {

    const fetchProject = async () => {
      try {

        const redirectCallback = () => navigate('/');
        const list = await ProjectService.GetProjectMemberByID(redirectCallback);
        // console.log(list)
        if (list[0].length > 0) {
          const filteredList = list.filter(project => project.ID !== 0); // Remove project with ID 0
          //console.log("after: "+filteredList)

          setProject(filteredList[0]);



          if (filteredList.length > 0) {
            let initialProjectID;
            if (localStorage.getItem("ProjectID") == "undefined" || localStorage.getItem("ProjectID") == "null") {

              const DefaultProjectList = list.filter(project => project.IsDefault == "1");

              if (DefaultProjectList.length > 0) {
                initialProjectID = DefaultProjectList[0].ID;
              }
              else {
                initialProjectID = filteredList[0][0].ID;
              }
            }
            else {
              initialProjectID = localStorage.getItem("ProjectID");
            }
            setProjectID(initialProjectID);
            localStorage.setItem("ProjectID", initialProjectID);
            // fetchJob(initialProjectID, "0", "10");
          }
        }
      } catch (error) {
        console.error('Error fetching projects:', error);
      }
    };

    fetchProject();
  }, [CustomerID, AssetID, StockID, ContractID, JobTab]);



  const handleCloseModal = async () => {
    localStorage.setItem('JobID', "0");
    fetchJob(ProjectID, "0", pageSize, searchQuery);
    setIsJobDetailModal(false);
  };
  const handleCloseSummaryModal = async () => {
    localStorage.setItem('JobID', "0");
    setCurrentPage(1);
    setIsModalOpen(false);
  };
  const handleSuccessSummaryModal = async (submissionType, JobID) => {
    debugger;
    localStorage.setItem('JobID', "0");
    fetchJob(ProjectID, currentPage, pageSize, searchQuery);
    setIsModalOpen(false);
    if (submissionType === "1") {
      handleEditClick(JobID);
    }

  };

  const handleDeleteClick = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    const ID = selectedId;
    if (ID > 0) {
      Swal.fire({
        title: t('deleteConfirmation'),
        text: t('deleteWarning'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await JobService.DeleteJob(redirectCallback, ID);
            fetchJob(ProjectID, currentPage, pageSize, searchQuery);
            setCurrentPage(1);
            setSelectedId("0");
            Swal.fire(
              t('deleteSuccess'),
              t('deleteSuccessMessage'),
              'success'
            );
          } catch (error) {
            console.error('Error deleting job:', error);
            Swal.fire(
              t('deleteError'),
              t('deleteErrorMessage'),
              'error'
            );
          }
        }
      });
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to delete job.',
        'warning'
      );
    }
  };

  const handleCreateJobClick = () => {

    localStorage.setItem('JobID', "0");
    localStorage.setItem('JobCostID', "0");
    localStorage.setItem('HasRecordUpdated', "0");
    if (ProjectID) {
      setIsModalOpen(true);
      setValidationError(''); // Clear any previous validation error
    } else {
      Swal.fire(
        'Error!',
        'Please select at least one project to create the job.',
        'warning'
      );
    }
  };

  const handleEditClick = (JobID) => {
    try {
      localStorage.setItem('JobID', JobID);
      localStorage.setItem('HasRecordUpdated', "0");
      navigate(`/JobDetailMobile?JobID=${JobID}&CustomerID=0`);
    }
    catch (error) {
      alert(error);
    }
  };


  const handleCheckboxChange = (event) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      IsOutstanding: event.target.checked, // Assuming IssuePriorityID is the field name
    }));
    // setJobData([]);
    if (event.target.checked === true) {
      setShowCompleted(1);
    }
    else {
      setShowCompleted(0);
    }
  };
  const handleRowCheckboxChange = (event, id) => {
    event.stopPropagation();
    setSelectedId((prevSelectedId) => (prevSelectedId === id ? "0" : id)); // Toggle selection
  };
  const IsModuleAssigned = async () => {
    try {
      const CompanyID = localStorage.getItem("CompanyID");
      const Modules = await ModuleService.GetModuleByClientID(CompanyID, "10");
      if (Modules.length === 0) {
        Swal.fire(
          'UnAuthorzied Access!',
          'Sorry, You are not authorized to access this module.',
          'warning'
        );
        redirecttoUnAuthorzied();
      }
    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };
  const handlePageChange = (page) => {
    setJobData([]);
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);

    }
  };

  // Handle Page Size Change
  const handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    setPageSize(newPageSize);
    setPageSizeInCookie(newPageSize);
    setCurrentPage(1); // Reset to the first page
  };
  const handleSearch = async (event) => {
    setCurrentPage(1);
    setJobData([]);
    const query = event.target.value.toLowerCase();

    setSearchQuery(query);
    const jobsData = await JobService.GetAllJobsMobile(redirectCallback, CustomerID, AssetID, StockID, ContractID, ProjectID, currentPage, pageSize.toString(),
      query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), selectedStatus);
    debugger;
    setJobData(jobsData);
  };


  const handleSort = async (key) => {
    debugger
    setCurrentPage(1);
    const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ key, direction });
    const jobsData = await JobService.GetAllJobsMobile(
      redirectCallback,
      CustomerID,
      AssetID,
      StockID,
      ContractID,
      ProjectID,
      "1",
      pageSize.toString(),
      searchQuery.toString(),
      key.toString(),  // Use current sortConfig directly
      direction.toString(),
      selectedStatus
    );

    const JobCount = await JobService.GetJobCountMobile(
      redirectCallback,
      CustomerID,
      AssetID,
      StockID,
      ContractID,
      ProjectID,
      searchQuery,
      selectedStatus
    );

    setJobCount(JobCount[0].JobCount);
    setJobData(jobsData);
    setFilteredJobList(jobsData);
    setTotalPages(Math.ceil(JobCount[0].JobCount / pageSize));
  };
  const handleSearchButtonClick = async () => {
    setCurrentPage(1); // Reset to first page
    setJobData([]); // Clear previous data
    const query = searchQuery.toLowerCase(); // Use current searchQuery state

    const jobsData = await JobService.GetAllJobsMobile(
      redirectCallback,
      CustomerID,
      AssetID,
      StockID,
      ContractID,
      ProjectID,
      currentPage,
      pageSize.toString(),
      query.toString(),
      sortConfig.key.toString(),
      sortConfig.direction.toString(),
      selectedStatus
    );

    setJobData(jobsData); // Update data

    const JobCount = await JobService.GetJobCountMobile(redirectCallback, CustomerID, AssetID, StockID, ContractID, ProjectID, searchQuery, selectedStatus);
    setJobCount(JobCount[0].JobCount);


    setJobData(jobsData);
    setFilteredJobList(jobsData); // Update filtered list for rendering
    setTotalPages(Math.ceil(JobCount[0].JobCount / pageSize)); // Set total pages dynamically
  };

  const defaultColumns = [
    "jobNo",
    "jcustomer",
    "priority",
    "category",
    "Jdescription",
    "JdueDate",
    "JdateCreated",
    "assignedTo",
    "Jprice",
    "Jstatus"
  ];

  const columnOptions = [
    { value: "jobNo", label: "Job No" },
    { value: "jcustomer", label: "Customer" },
    { value: "priority", label: "	Priority" },
    { value: "category", label: "Category" },
    { value: "Jdescription", label: "Description" },
    { value: "JdueDate", label: "Due Date" },
    { value: "JdateCreated", label: "Date Created" },
    { value: "assignedTo", label: "Assigned To" },
    { value: "Jprice", label: "Price" },
    { value: "Jstatus", label: "Status" }
  ];

  const getStoredColumns = () => {
    const storedColumns = Cookies.get(`JobsColumns_${CompanyID}`);
    return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
  };

  const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
  const handleColumnChange = (selectedOptions) => {
    setVisibleColumns(selectedOptions);

    // Save selection to cookies (valid for 1 year)
    Cookies.set(`JobsColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
  };


  return (
    <div>
      {loading && (
        <div class="loading">
          <div class="d-table">
            <div class="d-tablecell">
              <span class="loader">
                <span class="loader-inner"></span>
              </span>
            </div>
          </div>
        </div>
      )}
      {(CustomerID === 0 || CustomerID === "") && (AssetID === 0 || AssetID === "")
        && (StockID === 0 || StockID === "") && (ContractID === 0 || ContractID === "") && (
          <Common showAddButton={'yes'} handleAddTask={handleCreateJobClick}
            showDeleteButton={'yes'} handleDeleteItem={handleDeleteClick} ModuleID={"10"} />
        )}
      <div className="main-content-header row mb-3">
        {(CustomerID === 0 &&
          <div className="col-sm-12">
            <h1>Jobs Mobile</h1>
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card mb-30">
            <div className="card-body">

              <div className="table-responsive">

                <div className="row mb-3 d-flex align-items-center">
                  {/* Page Size Selector */}




                  <div className="col-4 col-md-3 d-flex align-items-center">

                    <select className="form-control"

                      value={selectedStatus}
                      onChange={(e) => {
                        const status = e.target.value;
                        setSelectedStatus(status);
                        Cookies.set('selectedStatus', status, { expires: 365 });
                      }}
                    >
                      <option value="">--All--</option>
                      {IssueStatusList.map((issue) => (
                        <option key={issue.ID} value={issue.ID}>
                          {issue.StatusName}
                        </option>
                      ))}
                    </select>
                  </div>

                </div>

                <div className="row mb-3 d-flex align-items-center">
                  {/* Page Size Selector */}
                  <div className="col-4 col-md-3 d-flex align-items-center">

                    <select
                      id="pageSize"
                      className="form-control form-control-sm"
                      value={pageSize}
                      onChange={handlePageSizeChange}
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                  </div>

                  {/* Search Field */}
                  <div className="col-8 col-md-3 d-flex align-items-center justify-content-end">
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="form-control form-control-sm me-2"
                      placeholder="Search..."
                    />
                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                      <img src="assets/img/resources/search.png" className="top-icon" alt="Search" />
                    </button>
                  </div>
                </div>




                <div style={{ maxHeight: "80vh", overflow: "auto" }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <tbody>
                      {jobList.map((job, index) => (
                        <>
                          <tr key={index} onClick={() => handleEditClick(job.IssueID)}>
                            <td style={{
                              fontWeight: 'bold',
                              padding: '10px',
                              width: '70%',
                              whiteSpace: 'normal',
                              wordBreak: 'break-word'
                            }}>
                              {job.CompanyName}
                            </td>
                            <td style={{
                              textAlign: 'right',
                              padding: '10px',
                              fontWeight: 'bold',
                              width: '30%'
                            }}>
                              {job.bnt_OrderNumber}
                            </td>
                          </tr>
                          <tr key={index} onClick={() => handleEditClick(job.IssueID)}>
                            <td  style={{
                              padding: '10px',
                              whiteSpace: 'normal',
                              wordBreak: 'break-word',
                              borderBottom: '1px solid #ccc',

                            }}>
                              {job.IssueTitle && job.IssueTitle.length > 80
                                ? `${job.IssueTitle.substring(0, 80)}...`
                                : job.IssueTitle}
                              <br />

                              <span style={{fontSize:"11px",color:"#212529"}}>  {job.Address1 && job.Address1.length > 80
                                ? `${job.Address1.substring(0, 80)}...`
                                : job.Address1}</span>
                            </td>
                            <td style={{
                              textAlign: 'right',
                              padding: '10px',
                              fontWeight: 'bold',
                              width: '30%'
                            }}>
                               {job.vc_SupplierInvoiceNo ? `(${job.vc_SupplierInvoiceNo})` : ''}
                            </td>
                          </tr>

                        </>
                      ))}
                    </tbody>
                    <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white", marginTop: "10px", marginBottom: "10px" }}>
                      <tr>
                        <td colSpan={11}>
                          <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>


                            {/* Last Page Button */}
                            <button
                              style={{ padding: '5px 8px', float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(totalPages)} // Navigate to last page
                              disabled={currentPage === totalPages}
                            >
                              Last
                            </button>

                            {/* Next Page Button */}
                            <button
                              style={{ padding: '5px 8px', float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            >
                              Next
                            </button>

                            <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                              Page {currentPage} of {totalPages}
                            </span>

                            {/* Previous Page Button */}
                            <button
                              style={{ padding: '5px 8px', float: "right", marginRight: "5px", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              Prev
                            </button>

                            {/* First Page Button */}
                            <button
                              style={{ padding: '5px 8px', float: "right" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(1)} // Navigate to first page
                              disabled={currentPage === 1}
                            >
                              First
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>



                  {/* Page Size Selector */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default JobList;